/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from "@reduxjs/toolkit";
import FichaInfoService from "@/services/FichaInfoService";

const handler = (name, asyncFunction) =>
  createAsyncThunk(`fichaInfo/${name}`, async (arg) => {
    const data = await asyncFunction(arg);
    return data;
  });

export const getFichaInfoData = handler(
  "getFichaInfoData",
  FichaInfoService.getFichaInfoData
);
export const getCustomAgentBranch = handler(
  "getCustomAgentBranch",
  FichaInfoService.getCustomAgentBranch
);
export const saveProfileEdition = handler(
  "saveProfileEdition",
  FichaInfoService.saveProfileEdition
);
export const sendFeedback = handler(
  "sendFeedback",
  FichaInfoService.sendFeedback
);
export const sendTrackEvent = handler(
  "sendTrackEvent",
  FichaInfoService.sendTrackEvent
);
